<template >
  <div
    class="position-relative"
  >

    <div
      v-if="
        !is_finished
      "
      class="input-group"
    >
      <input
          type="file"
          class="form-control"
          accept="video/*"
          @change="handleFileChange( $event )"
          :disabled="is_uploading"
      />
      <button
          class="btn btn-primary"
          @click.prevent="handleUploadStart( $event )"
          :disabled="!file"
      >
        <i class="bi bi-cloud-upload me-1"></i> [upload]
      </button>
    </div>




    <div
      v-if="is_uploading"
      class="position-absolute z-3 top-0 bottom-0 start-0 end-0 d-flex justify-content-center align-items-center"
      style="backdrop-filter: blur(5px); background-color: rgba(255, 255, 255, 0.3);"
    >
        <div class="spinner-border text-secondary" role="status">
          <span class="visually-hidden">{{$t('content.loading_short')}}</span>
        </div>
        <span class="ms-2">
          {{$t('content.loading_short')}}
          <span
            @click.prevent="cancelUpload()"
            class="link-danger btn-link ms-2"
          >
            <i class="bi bi-x-circle me-1"></i> zrusit
          </span>
        </span>
    </div>
  </div>



  <div
      v-if="is_uploading && !is_finished"
      class="progress-stacked mt-2"
  >
    <div
        class="progress"
        role="progressbar"
        :style="'width: ' + progressFull +'%'"
    >
      <div class="progress-bar text-end pe-2">
        <template v-if="progressFull > 40">
          {{progressFull}}%
        </template>

      </div>
    </div>

    <div
        class="progress"
        role="progressbar"
        :style="'width: ' + (100 - progressFull) +'%'"
    >
      <div class="progress-bar bg-secondary-subtle text-primary fw-bold text-end pe-2">
        <template v-if="progressFull <= 40">
        {{progressFull}}%
        </template>
      </div>
    </div>
  </div>


  <div
    v-if="is_finished"
    class="d-flex -justify-content-center align-items-center mt-2"
  >
    <div
      class="text-success"
    >
      <i class="bi bi-check-circle-fill me-2"/>
      <span>Nahrano v poradku</span>
    </div>

  </div>

  <display-debug>
    <template #debugView>
      is_finished: {{is_finished}}
    </template>
  </display-debug>
  <display-debug>
    <template #debugView>
      is_uploading: {{is_uploading}}
    </template>
  </display-debug>
  <display-debug>
    <template #debugView>
      inputObj: {{inputObj.params}}
    </template>
  </display-debug>









  <div
  v-if="1==0"
  >
    <!--
    <h2>TextInput - {{inputObj.title}} [{{inputObj.display}}]</h2>
    -->
    <input
        :type="this.inputObj.type"
        v-model="inputModel"
        :required="this.inputObj.required"
        :disabled="(this.inputObj.readonly)? 'disabled': false"
        :readonly="(this.inputObj.readonly)? 'readonly': false"
        @click="inputClick"
        @change="setOffPrefill"
        @input="setOffPrefill"
        :class="'form-control' + (this.inputObj.invalid? ' is-invalid': '')"
    />
  </div>

  <div v-if="inputObj.type == 'redirect_target'" class="mt-1">
    <template v-for="item in inputObj.params.btn_params">
    <span @click.prevent="addUtmParams(item.params)"
      class="btn btn-sm btn-outline-secondary me-1"
    >
      <i
          v-if="item.ico"
          :class="item.ico + ' me-1'"
      ></i>
      {{item.title}}
    </span>
    </template>
  </div>

  <version-control-input
      v-if="inputObj.versions"
      v-model="inputModel"
      :versions="inputObj.versions"
  />



  <!--
  <pre>{{inputObj}}</pre>
  -->
</template>

<script>

import axios from "axios";
import VersionControlInput from '@/components/general/form/inputs/_common/VersionControl'
import CountryFlag from "vue-country-flag-next";

export default {
  name: "UploadChunkFile",
  components: {
    VersionControlInput,
  },
  props: {
    "inputObj": Object,
    "formObj": Object,
    "modelValue": [Object, String, Number],
    "activeLang": {
      type: [String],
      required: false,
      default: null,
    },
    "xCHUNK_SIZE": 5 * 1024 * 1024,
  },
  data() {
    return {
      inputModel: null,
      file: null,
      is_uploading: false,
      is_finished: false,
      upload_progress_precent: 5,
      progressIndicator: null,
      CHUNK_SIZE: 5 * 1024 * 1024,
    }
  },
  mounted() {

    this.inputModel = this.inputObj.val;

  },
  computed: {
    upload_progress_precent_left() {
      return 100 - this.upload_progress_precent;
    },
    progressFull() {
      if (!this.progressIndicator) {
        return null;
      }

      const values = Object.values(this.progressIndicator);
      if (values.length === 0) {
        return 0;
      }

      const sum = values.reduce((acc, value) => acc + value, 0);

      // Spočítáme a vrátíme průměr
      //return sum / values.length;
      //const res =
      return parseFloat((sum / values.length).toFixed(1));
    }
  },
  methods: {
    handleFileChange(event) {
      const selectedFile = event.target.files[0];
      if (selectedFile) {
        this.file = selectedFile;

        console.log('dev handleFileChange', selectedFile)

        //this.upload_progress_precent = 0;
        //this.statusText = '';
      }
    },
    async handleUploadStart(event) {
      if (!this.file) {
        return
      };

      this.abortController = new AbortController();

      const totalChunks = Math.ceil(this.file.size / this.CHUNK_SIZE);
      const fileId = `${Date.now()}-${this.file.name}`; // Unikátní ID pro server

      //console.log('dev handleUploadStart', this.CHUNK_SIZE, this.file.size, totalChunks)
      //console.log('dev handleUploadStart', this.file.name, this.file.size, totalChunks, fileId)

      this.is_uploading = true;
      this.progressIndicator = {};
      for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
        this.progressIndicator[chunkIndex] = 0;
      }




      try {
        for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
          //console.log('dev handleUploadStart CHUNKt', chunkIndex)
          // Pokud mezitím uživatel kliknul na zrušit, vyskočíme z cyklu
          if (!this.is_uploading) break;

          const start = chunkIndex * this.CHUNK_SIZE;
          const end = Math.min(start + this.CHUNK_SIZE, this.file.size);

          // Vyřízneme kousek souboru
          const chunk = this.file.slice(start, end);


          //console.log('dev handleUploadStart axios request', chunkIndex)
          // Příprava dat pro POST požadavek
          const formData = new FormData();
          formData.append('chunk', chunk);
          formData.append('chunkIndex', chunkIndex);
          formData.append('totalChunks', totalChunks);
          formData.append('fileId', fileId);
          formData.append('fileName', this.file.name);

          this.statusText = `Posílám část ${chunkIndex + 1} z ${totalChunks}`;

          // Odeslání konkrétního kousku

          axios.defaults.baseURL = this.getBaseRoot();
          axios({
            method: 'post',
            url: this.inputObj.params.path.upload,
            data: formData,
            withCredentials: true,
            headers: this.getRequestHeaderUpload(),
            signal: this.abortController.signal,
            onUploadProgress: (progressEvent) => {
              if (!progressEvent.total) {
                return;
              }
              const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              this.progressIndicator[chunkIndex] = percent;
            },
          }).then((res) => {

            if(
                typeof res.data.response.file_uploaded_path != "undefined"
                && res.data.response.file_uploaded_path
            ) {
              this.is_finished = true;
              this.is_uploading = false;
              this.inputModel = res.data.response.file_uploaded_path;
              console.log('[htmlEditor.loadCustomButtons] RES',  res.data.response)
            }

            //console.log('[htmlEditor.loadCustomButtons] RES', res.data)

          }).catch(function(err){
            console.log('[htmlEditor.loadCustomButtons] ERR',  err )
          })

        }
      } catch (error) {
        if (axios.isCancel(error)) {
          this.statusText = 'Nahrávání bylo zrušeno uživatelem.';
        } else {
          console.error(error);
          this.statusText = 'Během nahrávání došlo k chybě.';
        }
        this.isUploading = false;
      }

    },
    cancelUpload() {
      if (this.abortController) {
        this.abortController.abort();
        this.is_finished = false;
        this.is_uploading = false;
      }
    },

    // Resetování stavu po úspěchu nebo chybě
    resetUploader() {
      this.is_finished = false;
      this.is_uploading = false;
      this.file = null;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
    },


  },
  watch: {
    inputObj: {
      handler() {
        this.inputModel = this.inputObj.val;
      },
      deep: true,
      immediate: true
    },
    inputModel( newVal){

      if(this.inputObj.name == 'slug' && newVal.length == 0){
        this.inputObj.is_locked = false;
      }
      //timer
      if(this.timer) clearInterval(this.timer);
      const delay = this.timer_delay
      const pseudo_this = this;
      this.timer = setTimeout(
          () => {
          //start timer function content
            //tohle je slug input a jeho prevod na spravny format
            if (
                typeof pseudo_this.inputObj.slug != 'undefined'
                && typeof pseudo_this.inputObj.slug.is_slug != 'undefined'
            ){
              //console.log("dev slug inputObj SLUG format")
              newVal = pseudo_this.createSlugFormat(newVal);
              this.inputModel = newVal;
              this.inputObj.val = newVal
            }else if(
                typeof pseudo_this.inputObj.path_format != 'undefined'
                && typeof pseudo_this.inputObj.path_format.is_path_format != 'undefined'
            ){
              newVal = pseudo_this.createPathFormat(newVal);
              this.inputModel = newVal;
              this.inputObj.val = newVal
              console.log('dev patha', newVal)
            }else{
              this.inputObj.val = newVal

            }

            //pokud z inputu vytvarim dalsi inpu ve formatu slug

            if(
                typeof pseudo_this.inputObj.slug != 'undefined'
                && typeof pseudo_this.inputObj.slug.section != 'undefined'
                && typeof pseudo_this.inputObj.slug.input != 'undefined'
                && typeof pseudo_this.formObj[pseudo_this.inputObj.slug.section].inputs[pseudo_this.inputObj.slug.input].disable_auto_fill == 'undefined'
              && pseudo_this.formObj[pseudo_this.inputObj.slug.section].inputs[pseudo_this.inputObj.slug.input].is_locked == false
            ) {
              pseudo_this.formObj[pseudo_this.inputObj.slug.section].inputs[pseudo_this.inputObj.slug.input].val = newVal
            }



            //update parent
            //console.log('dev textarea', newVal)
            pseudo_this.$emit('update:modelValue', newVal )
          //end timer function content
          },
          this.timer_delay
      )
    },
  },
};
</script>